export const MIN_STRING_LENGTH = 1

export const MAX_LABEL_LENGTH = 50
export const MAX_NAME_LENGTH = 50

